import { Injectable } from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import {FaqCategoryListDto} from "../../../../modules/faq/dto/FaqCategoryListDto";
import {finalize} from "rxjs/operators";
import {AuthService} from "../../../../modules/auth";

@Injectable({
  providedIn: 'root'
})
export class TwoStepVerificationService {
  API_URL_thynk = `${environment.apiUrl}`;
  protected token = '';

  protected http: HttpClient;
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  protected userID = '';
  protected userName = '';

  get isLoading$() {
    return this._isLoading$.asObservable();
  }
  constructor(http: HttpClient, authService: AuthService) {
    this.http = http;
    this.userID = authService.tempUserValue ? authService.tempUserValue.userId : '';
    this.userName = authService.tempUserValue ? authService.tempUserValue.username : '';
    this.token = authService.currentUserTokenValue ;


  }
  getQRCode(): Observable<any>  {
    this._isLoading$.next(true);
    return this.http
      .get<any>(`${this.API_URL_thynk}/tfa/generate-qrcode`,
        {
          headers: new HttpHeaders({
            Authorization: `Bearer ${this.token}`,
          })}).pipe(finalize(() => this._isLoading$.next(false)));
  }
  enableOTOPCode(code: any): Observable<any>  {
    this._isLoading$.next(true);
    return this.http
      // .post<any>(`${this.API_URL}/2fa/qrcode/validate/${this.userID}/${code}`, {})
      .post<any>(`${this.API_URL_thynk}/tfa/enable`, {
        "otop": code
      },
        {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      })
    })
      .pipe(finalize(() => this._isLoading$.next(false)));
  }
  disableOTOPCode(code: any): Observable<any>  {
    this._isLoading$.next(true);
    return this.http
      // .post<any>(`${this.API_URL}/2fa/qrcode/validate/${this.userID}/${code}`, {})
      .post<any>(`${this.API_URL_thynk}/tfa/disable`, {
        "otop": code
      },
        {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      })
    })
      .pipe(finalize(() => this._isLoading$.next(false)));
  }
  validateOTOPCode(code: any): Observable<any>  {
    this._isLoading$.next(true);
    return this.http
      .post<any>(`${this.API_URL_thynk}/auth/validate-otop`,  {
        "username": this.userName,
        "userId": this.userID,
        "otop": code
      })
      // .post<any>(`${this.API_URL}/enable/${this.userID}/${code}`, {})
      .pipe(finalize(() => this._isLoading$.next(false)));
  }
}
